import api from "../../utils/Api";
import {
  READ_NOTIFICATIONS_REQUEST,
  READ_NOTIFICATIONS_SUCCESS,
  READ_NOTIFICATIONS_ERROR,
} from "./ReadNotificationTypes";

export const readNotificationsRequest = () => {
  return {
    type: READ_NOTIFICATIONS_REQUEST,
  };
};

export const readNotificationsSuccess = (readNotifications) => {
  return {
    type: READ_NOTIFICATIONS_SUCCESS,
    payload: readNotifications,
  };
};

export const readNotificationsFailure = (error) => {
  return {
    type: READ_NOTIFICATIONS_ERROR,
    payload: error,
  };
};

export const readNotifications = (notification_id) => {

    const headers = {
        'Content-Type': 'application/json',
        Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
        };

        const payload = {
            notification_id: notification_id
        }
  return async (dispatch) => {
    dispatch(readNotificationsRequest());
    try {
        const response = await api.put("notification", payload, {
            headers: headers,
          });
      const readNotificationsData = response.data.data;
      dispatch(readNotificationsSuccess(readNotificationsData));
    } catch (error) {
      console.log("Redux error - ", error.response.data.message);
      const errorMsg = error.response.data.message;
      dispatch(readNotificationsFailure(errorMsg));
    }
  };
};
